<template>
    <div
        :id="
            content.columnId && content.columnId[$i18n.locale]
                ? content.columnId[$i18n.locale].current
                : content._key
        "
        class="d-md-block d-sm-none"
        style="width: 100%; height: 100%"
    >
        <div :style="calcImageInlineStyle()" style="height: 100%">&nbsp;</div>
    </div>
</template>
<script>
export default {
    name: 'ColumnBackgroundImage',
    props: {
        content: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {}
    },
    methods: {
        calcImageInlineStyle() {
            const imageUrl = this.$img(`${process.env.ASSET_HOSTNAME}${
                this.content?.sanityImageBackground?.selectedImage?.asset
                    ?.originalFilename || 'c3controls-icon.jpg'
            }?fit=scale`, {format: 'webp'})
            // const imageUrl = `${process.env.ASSET_HOSTNAME}${
            //     this.content?.sanityImageBackground?.selectedImage?.asset
            //         ?.originalFilename || 'c3controls-icon.jpg'
            // }?fit=scale`
            let focus = this.content?.sanityImageBackground
                ? this.content?.sanityImageBackground.focus
                : 'center center'
            if (focus === 'topLeft') {
                focus = 'left top'
            } else if (focus === 'topRight') {
                focus = 'right top'
            } else if (focus === 'bottomRight') {
                focus = 'right bottom'
            } else if (focus === 'bottomLeft') {
                focus = 'left bottom'
            }
            return `background-image:url(${imageUrl});background-size:${
                this.content?.bgSize || 'cover'
            };background-repeat:no-repeat;background-position: ${focus};height:100%`
        },
    },
}
</script>
